import { IGLAccountActions, GLAccountContext } from './actions.types';
import { IGLAccountData } from '@/models';

export const actions: IGLAccountActions = {
  fetchGLAccounts(context: GLAccountContext): Promise<void> {
    return this.$services.accounting
      .fetchGLAccounts()
      .then((accounts: IGLAccountData[]) => {
        context.commit('SET_GL_ACCOUNTS', accounts);
      });
  },

  fetchGLAccount(context: GLAccountContext, payload: number): Promise<void> {
    return this.$services.accounting
      .fetchGLAccount(payload)
      .then((account: IGLAccountData) => {
        const index = context.state.accounts.findIndex(
          (v: IGLAccountData) => v.id === account.id
        );
        if (index === -1) {
          context.commit('ADD_GL_ACCOUNT', account);
        } else {
          context.commit('UPDATE_GL_ACCOUNT', account);
        }
      });
  },

  createGLAccount(
    context: GLAccountContext,
    payload: IGLAccountData
  ): Promise<void> {
    return this.$services.accounting
      .createGLAccount(payload)
      .then((account: IGLAccountData) =>
        context.commit('ADD_GL_ACCOUNT', account)
      );
  },

  updateGLAccount(
    context: GLAccountContext,
    payload: IGLAccountData
  ): Promise<void> {
    return this.$services.accounting
      .updateGLAccount(payload)
      .then((account: IGLAccountData) => {
        const index = context.state.accounts.findIndex(
          (v: IGLAccountData) => v.id === account.id
        );
        if (index === -1) {
          context.commit('ADD_GL_ACCOUNT', account);
        } else {
          context.commit('UPDATE_GL_ACCOUNT', account);
        }
      });
  },

  deleteGLAccount(context: GLAccountContext, payload: number): Promise<void> {
    return this.$services.accounting.deleteGLAccount(payload).then(() => {
      context.commit('REMOVE_GL_ACCOUNT', payload);
    });
  }
};
